import { Component, AfterViewInit, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, AuthService, BaseFilterCollapse, BaseFilterCollapseService, MessageService } from '../../../../../core';
import { ClienteInternetFilter } from './cliente-internet-filter';
import { clienteCadastros, clienteCadastroCliente } from '../../cadastro';
import { clienteSituacoes } from '../../situacao';
import { Cliente } from '../../cliente';
import { Representante } from '../../../representante';
import { Cidade } from '../../../../cidade';
import { Estado, EstadoCrudHttpService } from '../../../../estado';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';

@Component({
    selector: 'sgt-cliente-internet-filter-collapse',
    templateUrl: './cliente-internet-filter-collapse.component.html',
    styleUrls: ['./cliente-internet-filter-collapse.component.less']
})
export class ClienteInternetFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    isRepresentante: boolean;

    // Filter
    @Input() filter: ClienteInternetFilter;
    @Output() filterInitialized = new EventEmitter<any>();
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse', {static: true}) filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = true;

    // Cadastros
    // isFirstChangeCadastros = true;
    multiselectCadastrosOptions: IMultiSelectOption[];
    multiselectCadastrosSettings: IMultiSelectSettings = {
        enableSearch: true,
        containerClasses: 'container-multiselect',
        showCheckAll: true,
        showUncheckAll: true,
        dynamicTitleMaxItems: 4,
    }
    multiselectCadastrosTexts: IMultiSelectTexts = {
        checkAll: 'Selecionar todos',
        uncheckAll: 'Limpar',
        checked: 'cadastros selecionado',
        checkedPlural: 'cadastros selecionados',
        searchPlaceholder: 'Pesquisar...',
        defaultTitle: 'Selecionar cadastros',
        allSelected: 'Todos selecionados',
        searchEmptyResult: 'Nenhum cadastro encontrado',
        searchNoRenderText: 'Digite para pesquisar'
    }

    situacoes = clienteSituacoes;
    estados: Estado[] = [];

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private estadoCrudHttpService: EstadoCrudHttpService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        this.initFilter();
    }

    /** Seta os filtros padrões que devem estar adicionados ao criar o filtro */
    private setDefaultFilters() {
        // Cadastros
        this.filter.cadastros = [clienteCadastroCliente.id];

        this.isFilterDirty = true;
    }

    /** Cria o filtro de multiselect dos cadastros */
    private createFilterCadastros() {
        const selects: IMultiSelectOption[] = [];
        clienteCadastros.forEach(clienteCadastro => {
            selects.push({
                id: clienteCadastro.id,
                name: clienteCadastro.nome
            });
        });
        this.multiselectCadastrosOptions = selects;
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.createFilterCadastros();
        this.searchEstados();

        this.setDefaultFilters();
        this.filterInitialized.emit(); // Emitindo o evento de que o filtro foi inicializado
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
        this.setDefaultFilters();
    }

    /** Pesquisa todos os estados */
    private searchEstados() {
        this.estadoCrudHttpService.search()
            .subscribe(
                entities => this.estados = entities,
                (error: ApiError) => this.messageService.error(error.message,  'Erro ao pesquisar os estados para o filtro do cliente', error)
            );
    }

    /** Ao alterar os cadastros */
    onChangeCadastros() {
        this.isFilterDirty = true;
    }

    /** Ao alterar o cliente */
    onChangeCliente(cliente: Cliente) {
        if (cliente) {
            this.filter.idCliente = cliente.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idCliente = null;
        }
    }

    /** Ao alterar o representante */
    onChangeRepresentante(representante: Representante) {
        if (representante) {
            this.filter.idRepresentante = representante.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idRepresentante = null;
        }
    }

    /** Ao alterar a cidade */
    onChangeCidade(cidade: Cidade) {
        if (cidade) {
            this.filter.idCidade = cidade.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idCidade = null;
        }
    }
}
